<template>
  <section class="commonUploadWordPage">
    <el-form ref="ref_commonForm" class="common-form-self" :model="form" label-width="100px" @submit.native.prevent>
      <div v-for="(item, index) in form.wordList" :key="item.key" class="card">
        <div class="cont">
          <el-form-item
            label="单词"
            :prop="'wordList.' + index + '.wordName'"
            :rules="{
              required: true, message: '请输入单词名称', trigger: 'blur'
            }"
          >
            <el-input v-model="item.wordName" maxlength="20" placeholder="请输入单词名称" />
          </el-form-item>
          <el-form-item
            label="单词读音"
            :prop="'wordList.' + index + '.voice'"
            :rules="{
              type: 'array', required: true, message: '请上传单词读音音频', trigger: 'change'
            }"
          >
            <themeUploadList :code="code + 'Voice'" :file-list.sync="item.voice" accept=".mp3" :limit="1" tip="仅支持.mp3文件" />
          </el-form-item>
          <el-form-item
            label="卡片图"
            :prop="'wordList.' + index + '.img'"
            :rules="{
              type: 'array', required: true, message: '请上传卡片图', trigger: 'change'
            }"
          >
            <themeUploadAvatar :code="code + 'Img'" :file-list.sync="item.img" />
          </el-form-item>
          <el-form-item
            label="口型视频"
            :prop="'wordList.' + index + '.video'"
            :rules="{
              type: 'array', required: true, message: '请上传口型视频', trigger: 'change'
            }"
          >
            <themeUploadList :code="code + 'Video'" :file-list.sync="item.video" accept=".mp4" :limit="1" tip="仅支持.mp4文件" />
          </el-form-item>
        </div>
        <div class="button-bar">
          <el-button v-if="isShowAdd(index)" type="success" size="small" @click="addCard(index)">添加单词</el-button>
          <el-button v-if="form.wordList.length > 1" type="warning" size="small" @click="deleteCard(index)">删除</el-button>
          <!-- <i v-if="isShowAdd(index)" class="el-icon-circle-plus" @click="addCard(index)" />
          <i v-if="form.wordList.length > 1" class="el-icon-remove" @click="deleteCard(index)" /> -->
        </div>
      </div>

    </el-form>

  </section>
</template>

<script>
import themeUploadAvatar from './themeUploadAvatar'
import themeUploadList from './themeUploadList'
export default {
  components: {
    themeUploadAvatar,
    themeUploadList
  },
  props: {
    // 可添加关联单词最大个数
    maxNumber: {
      type: Number,
      default: 10
    },
    // 附件最大允许添加个数
    limit: {
      type: Number,
      default: 10
    },
    // 用于接口 传参 确定文件名编码用
    code: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default: () => {

      }
    }
  },
  data () {
    return {
      isShowUploadYinbiao: false
    }
  },
  watch: {
    form: {
      handler(val) {
        //
        this.$emit('formChange', val)
      },
      deep: true
    }
  },
  created () {

  },
  methods: {
    isShowAdd (index) {
      return (this.form.wordList.length - 1) === index && this.form.wordList.length < this.maxNumber
    },
    addCard (index) {
      this.form.wordList.push({ word: '', voice: [], img: [], video: [], key: Date.now() })
    },
    deleteCard (index) {
      this.$confirm('是否确认删除单词?', '提示', {
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.form.wordList.splice(index, 1)
      })
    },

    // 验证表单 必填验证，传给父组件
    validateForm () {
      let isvalidate = false
      this.$refs['ref_commonForm'].validate((valid) => {
        if (valid) {
          isvalidate = true
        } else {
          isvalidate = false
        }
      })
      return isvalidate
    }
  }
}
</script>

<style lang='scss'>
.commonUploadWordPage{
  .common-form-self{
    .card{
      border: 1px solid #EEEEEE;border-radius: 8px;padding:24px 0 0 0;margin-bottom:24px;
      &:last-child{margin-bottom:0;}
      .cont{
        border-bottom: 1px solid #EEEEEE;
        flex-grow: 1;
        display: flex;
        flex-wrap: wrap;
        .el-form-item{
          width: 40%;
          &:nth-child(odd){
            margin-right: 10%;
          }
        }
      }
      .button-bar{
        margin-right: 20px;
        text-align: right;
        padding:10px 0;
        // i{
        //   padding: 5px;
        //   cursor: pointer;
        //   font-size: 26px;
        //   color: #79C251;
        // }
        // i+i{
        //   margin-left: 20px;
        // }
      }

    }
  }
}
// .upload-form-self{
//   display: flex;
//   flex-wrap: wrap;
//   .el-form-item{
//     /*display: inline-block;*/
//     width: 40%;
//     &:nth-child(odd){
//       margin-right: 10%;
//     }
//   }
// }
</style>
